import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { DivBackgroundOpacity } from "@utils/extra-style";

const SiteAddress = (props) => {
  const { t, data, isActive } = props;

  return (
    <>
      <DivBackgroundOpacity opacity={isActive ? 1 : "0.2"}>
        <div>
          {data.street ? data.street : ""}
          {!!data.address && <br />}
          {parseInt(data.country, 10) === 1 && (
            <>
              {data.city ? " " + data.city : ""}
              {data.zipcode ? ", " + data.zipcode : ""}
            </>
          )}
          {parseInt(data.country, 10) !== 1 && (
            <>
              {data.zipcode ? " " + data.zipcode : ""}
              {data.city ? ", " + data.city : ""}
            </>
          )}
        </div>
      </DivBackgroundOpacity>
    </>
  );
};

SiteAddress.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(SiteAddress);
